module.exports = __webpack_public_path__ + "images/_/programs/zeroHeroes/images/characters/esmeralda_goober_goofy_smile-ea36a1f2dea26b0654b664d4bb49cb2f.png";


//////////////////
// WEBPACK FOOTER
// ./programs/zeroHeroes/images/characters/esmeralda_goober_goofy_smile.png
// module id = 445
// module chunks = 2